import Autocomplete from "react-google-autocomplete";
import { useIntl } from "react-intl";

type Props = {
  AddressFormat?: string;
  setMapInfo: any;
  setNewLatLng: any;
  form: any;
  name: string;
  label?: string;
};

const InputAddress = ({
  AddressFormat,
  setMapInfo,
  setNewLatLng,
  form,
  name,
  label,
}: Props) => {
  const intl = useIntl();
  const GetNamesLocation: any = (data: any) => {
    console.log(data);

    data?.map((e: any) => {
      switch (e.types[0]) {
        case "administrative_area_level_1":
          form.setFieldsValue({
            [name]: { City: e.long_name, main: e.long_name },
          });
          break;
        case "administrative_area_level_2":
          form.setFieldsValue({
            [name]: { District: e.long_name },
          });
          break;

        case "country":
          form.setFieldsValue({
            [name]: { Country: e.long_name },
          });
          break;
        default:
          // Handle any other types or do nothing for unhandled types
          break;
      }
    });
  };
  return (
    <div
      className="input-wrapper input-address-wrapper"
      style={{ width: "100%", marginBottom: "10px" }}
    >
      <div className="mb-2">{label}</div>
      <Autocomplete
        apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} // Use environment variable for API keys
        style={{ width: "100%", height: "40px", fontSize: "16px" }}
        placeholder={intl.formatMessage({
          id: "EnterAnAddress",
        })}
        defaultValue={AddressFormat}
        value={AddressFormat}
        onChange={(e: any) => setMapInfo(e.target.value)}
        className="rounded-lg border-solid transition-all duration-300 border-[1px] border-[#d9d9d9] p-4 hover:border-color-primary outline-none focus:border-color-primary"
        onPlaceSelected={(place: any) => {
          if (!place?.geometry) {
            console.error("No geometry data available for this place");
            return;
          }
          GetNamesLocation(place?.address_components);
          const lat = place?.geometry?.location?.lat();
          const lng = place?.geometry?.location?.lng();
          setMapInfo(place?.formatted_address);
          setNewLatLng({ lat, lng });
        }}
        options={{
          componentRestrictions: { country: "sa" },
          types: ["establishment"],
        }}
      />{" "}
    </div>
  );
};

export default InputAddress;
